import React from 'react'
import PropTypes from 'prop-types'
import IconLabel from './IconLabel'
import {VideoCameraFilled, CheckSquareFilled} from '@ant-design/icons'

const VideoProduct = ({product}) => {
  const variants = {
    some15: 'Vertikal SoMe 15',
    video15: 'Video 15',
    video20: 'Video 20',
    video30: 'Video 30',
    video40: 'Video 40',
    video45: 'Video 45',
    video90: 'Video 90',
    aero15: 'Aero 15',
    aero20: 'Aero 20',
    aero30: 'Aero 30',
    aero40: 'Aero 40',
    video60_drone: 'Video 60 + drone',
    video_60_aero_stills: 'Video 60 Aero + stills',
    video_40_aero_stills: 'Video 40 Aero + stills',
    video_viewing: 'Videovisning',
    some_horizontal: 'SoMe Horisontal',
    videobundle: 'Videobundle',
  }

  const {videoVariant, drone, teaser} = product
  const variantLabel = variants[videoVariant] || videoVariant

  return (
    <div className="selected-product-options VideoProduct">
      <IconLabel icon={<VideoCameraFilled />} label={variantLabel} />
      {drone && (
        <IconLabel icon={<CheckSquareFilled />} label="Med drone" />
      )}
      {teaser && (
        <IconLabel icon={<CheckSquareFilled />} label="Med teaser" />
      )}
    </div>
  )
}

VideoProduct.propTypes = {
  product: PropTypes.object.isRequired,
}

export default VideoProduct
